import { colors } from '@material-ui/core';

const white = '#FFFFFF';
const black = '#000000';

const colorsBrendKolizey = {
  yellow: {
    100: '#ffd633',
    500: '#ffcc00',
    900: '#b28e00'
  }
}


export default {
  type: 'dark',
  black,
  white,
  primary: {
    contrastText: black,
    dark: colorsBrendKolizey.yellow[900],
    main: colorsBrendKolizey.yellow[500],
    light: colorsBrendKolizey.yellow[100]
  },
  secondary: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue['A400'],
    light: colors.blue['A400']
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400]
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400]
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400]
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400]
  },
  text: {
    primary: colors.grey[200],
    secondary: colors.grey[400],
    link: colorsBrendKolizey.yellow[500]
  },
  background: {
    //default: '#F4F6F8',
    color: '#263238',
    default: '#333333',
    paper: '#1e1e1e'
  },
  icon: colors.grey[400],
  divider: colorsBrendKolizey.yellow[100]
};
